export const status_type_options = [
    {
        value: 1,
        label: "Active",
    },
    {
        value: 0,
        label: "Inactive",
    },
];
export const question_type_options = [
    {
        value: "DropdownSelect",
        label: "Single or Multiple Choice Question",
    },
    {
        value: "LikertScale",
        label: "Likert Scale Question (Red to Green or Orange to Red Scale)",
    },
    {
        value: "SliderInput",
        label: "Numeric Input Question (optionally you can define units)",
    },
    {
        value: "BoxChoice",
        label: "Box Choice Question with Single Answer",
    },
    {
        value: "CheckboxChoice",
        label: "Checkbox Choice Question with Multiple Answers",
    },
    {
        value: "RadioChoice",
        label: "Radio Choice Question with Single Answer",
    },
    {
        value: "DatePicker",
        label: "Date Picker Question",
    },
    {
        value: "MonthPicker",
        label: "Month Picker Question",
    }
];
export const variable_name_options = [
    {
        value: "medication",
        label: "Variable to Store Name of Main Medication [medication]",
    },
    {
        value: "other_medications_now",
        label: "Variable to Store Names of Minor Medications that you're currently taking [other_medications_now]",
    },
    {
        value: "other_medications_past",
        label: "Variable to Store Names of Past Medications [other_medications_past]",
    },
    {
        value: "other_medications",
        label: "Variable to Store Names of any other medications [other_medications]",
    },
    {
        value: "condition_therapy",
        label: "Variable to Store Name of Main Condition / Therapy [condition_therapy]",
    },
    {
        value: "minor_conditions_therapies,",
        label: "Variable to Store Names of Minor Conditions / Therapies [minor_conditions_therapies]",
    },
    {
        value: "other_conditions_therapies",
        label: "Variable to Store Names of Other Conditions / Therapies [other_conditions_therapies]",
    },
    {
        value: "early_side_effects",
        label: "Variable to Store Name of Early Side Effects [early_side_effects]",
    },
    {
        value: "other_side_effects",
        label: "Variable to Store Name of Other Side Effects [other_side_effects]",
    },
    {
        value: "current_side_effects",
        label: "Variable to Store Name of Current Side Effects [current_side_effects]",
    },
    {
        value: "forgotten_side_effects",
        label: "Variable to Store Name of Side Effects when forgot to take Medication [forgotten_side_effects]",
    },
    {
        value: "early_symptoms",
        label: "Variable to Store Name of Early Symptoms [early_symptoms]",
    },
    {
        value: "other_symptoms",
        label: "Variable to Store Name of Other Symptoms [other_symptoms]",
    },
    {
        value: "current_symptoms",
        label: "Variable to Store Name of Current Symptoms [current_symptoms]",
    },
    {
        value: "medication_rating",
        label: "Link it to the Question where we fetch medication Rating [medication_rating]",
    },
    {
        value: "activities",
        label: "Link it to the Question where we get answer for Activities [activities]",
    },
    {
        value: "dob",
        label: "Link it to the Question where we get Date of Birth [dob]",
    },
    {
        value: "gender",
        label: "Link it to the Question where we get Gender [gender]",
    },
    {
        value: "age",
        label: "Link it to the Question where we get Numeric Age Value [age]",
    }
];
export const survey_type_options = [
    {
        label: "Currently Taking this Medication",
        value: "1",
    },
    {
        label: "Have Taken this Medication in Past",
        value: "2",
    },
];
export const questionTypes = {
    DropdownSelect: "Single or Multiple Choice Question",
    LikertScale: "Likert Scale Question (Red to Green or Orange to Red Scale)",
    SliderInput: "Numeric Input Question (optionally you can define units)",
    BoxChoice: "Box Choice Question with Single Answer",
    CheckboxChoice: "Checkbox Choice Question with Multiple Answers",
    RadioChoice: "Radio Choice Question with Single Answer",
    DatePicker: "Date Picker Question",
    MonthPicker: "Month Picker Question",
    default: "Please select question type",
};

export const validVariables = [
    "medication",
    "other_medications_now",
    "other_medications_past",
    "other_medications",
    "condition_therapy",
    "minor_conditions_therapies",
    "other_conditions_therapies",
    "early_side_effects",
    "other_side_effects",
    "current_side_effects",
    "forgotten_side_effects",
    "early_symptoms",
    "other_symptoms",
    "current_symptoms",
    "medication_rating",
    "activities",
    "dob",
    "gender",
    "age"
];
